<template>
  <div
    class="offer offer-display"
    v-if="offer"
    :lang="offer.language || 'de'"
    :data-offer-language="offer.language || 'de'"
  >
    <ScrollSpy />
    <section
      v-if="!editable"
      class="header"
      id="ueberblick"
    >
      <div class="headerImage" :style="{ backgroundImage: `url(${randomImage})` }"></div>
      <b-container
      fluid
      class="pt-5 py-4"
      >
        <b-row>
          <b-col sm="7" class="my-5 py-5">
            <Heading
              :options="{ editable }"
              @dirty="showsave = true"
              class="text-white"
            />
          </b-col>

        </b-row>
        
      </b-container>
    </section>
    <b-container
      fluid
      class="pt-4"
    >
      <b-row class="meta-data">
        <b-col
          md="4"
          class="mb-4"
        >
          <CustomerAddress
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
        <b-col
          md="4"
          class="mb-4"
        >
          <SeminarDetails
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
        <b-col
          md="4"
          class="mb-4"
        >
          <ContactPerson
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          md="8"
          class="introduction mb-4"
        >
          <Introduction
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
        <b-col
          md="4"
          class="ekomi-col text-center mb-4"
        >
          <Ekomi
            :options="{ editable: false }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col class="trust mb-4">
          <TrustElements
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>

      <company-reviews
        v-if="offer.hash !== '6497f85ead'"
        @dirty="showsave = true"
        :editable="editable"
      />
      <seminar-reviews
        v-if="offer.hash !== '6497f85ead'"
        @dirty="showsave = true"
        :editable="editable"
      />

      <b-row class="sales-stats" v-if="!isOpenSeminar">
        <b-col>
          <SalesStats
            :options="{ editable: false }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <div class="page-break"></div>
      <b-row id="angebot">
        <b-col
          class="price-table"
          v-if="offer.id >= 6586"
        > <!-- Feature Release on 2023-08-04 -->
          <Offer
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
        <b-col
          class="price-table mb-4"
          v-else
        >
          <PricingTableLegacy
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col class="service mb-4">
          <ServiceList
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <div
        class="page-break"
        v-if="isInhouse"
      ></div>
      <b-row>
        <b-col
          class="service"
          :class="{ 'mb-4': isInhouse }"
        >
          <AdditionalInfo
            :options="{ editable }"
            @dirty="showsave = true"
          />
          <p>&nbsp;</p>
          <p>{{ $t('legal.externalTrainer') }}</p>
        </b-col>
      </b-row>
      <b-row v-if="isInhouse && !isRemoteOnly"><!-- && !offer.isRemote ??? macht das nicht sinn hier beachte fragen -->
        <b-col
          md="12"
          class="equipment"
        >
          <Equipment
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <div class="page-break"></div>
      <b-row
        v-if="seminar"
        id="schulungsinhalte"
      >
        <b-col
          md="12"
          class="mb-4 mt-4"
        >
          <SeminarContent
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <div class="page-break"></div>
      <b-row
        v-if="trainer"
        id="dozent"
      >
        <b-col
          class="trainer-col mb-4"
          :md="trainerRating && trainerRating.length && (editable || offer.showTrainerReviews) != 0 ? '8' : '12'"
        >
          <TrainerProfile
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
        <!-- TrainerReviews -->
        <trainer-reviews
          id="trainerReviews"
          :editable="editable"
          @dirty="showsave = true"
        ></trainer-reviews>

      </b-row>
      <b-row>
        <b-col>
          <ServiceContractNotice :offer-type-id="offer.offerType_id" />
        </b-col>
      </b-row>
      <div class="page-break"></div>
      <b-row id="gfucyrusag">
        <b-col class="about mb-4">
          <AboutGfu
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <b-row id="durchfuehrungsarten">
        <b-col class="execution mb-4">
          <ExecutionTypes
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <div class="page-break"></div>
      <b-row id="services">
        <b-col md="12">
          <ServiceCards
            :options="{ editable }"
            @dirty="showsave = true"
          />
        </b-col>
      </b-row>
      <b-row class="offer-imprint">
        <b-col cols="12">
          <div class="offer-imprint-line"></div>
        </b-col>
        <b-col
          md="3"
          class="offer-imprint-text"
        >
          <p class="mb-0"><strong>{{ $t('legal.board') }}</strong> Oliver Mostert</p>
          <p class="mb-0"><strong>{{ $t('legal.supervisoryBoard') }}</strong> Miriam Löffler</p>
        </b-col>
        <b-col
          md="3"
          class="offer-imprint-text"
        >
          <p class="mb-0"><strong>Deutsche Bank</strong></p>
          <p class="mb-0">IBAN: DE48 3707 0060 0111 5823 00</p>
          <p class="mb-0">BIC: DEUTDEDK</p>
        </b-col>
        <b-col
          md="3"
          class="offer-imprint-text"
        >
          <p class="mb-0"><strong>Sparkasse KölnBonn</strong></p>
          <p class="mb-0">IBAN: DE84 3705 0198 1933 6083 49</p>
          <p class="mb-0">BIC: COLSDE33</p>
        </b-col>
        <b-col
          md="3"
          class="offer-imprint-text"
        >
          <p class="mb-0">{{ $t('legal.taxNumber') }} 216/5871/0707</p>
          <p class="mb-0">{{ $t('legal.vatId') }} DE122654743</p>
          <p class="mb-0">{{ $t('legal.court') }}</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <div
    v-else
    class="loading-page"
  >
    <div class="loading-icon"></div>
  </div>
</template>

<script>
import Heading from '../components/editor/Heading';
import CustomerAddress from '../components/editor/CustomerAddress';
import SeminarDetails from '../components/editor/SeminarDetails';
import ContactPerson from '../components/editor/ContactPerson';
import Introduction from '../components/editor/Introduction';
import Ekomi from '../components/editor/Ekomi';
import SalesStats from '../components/editor/SalesStats';
import ServiceList from '../components/editor/ServiceList';
import ServiceContractNotice from '../components/editor/ServiceContractNotice';
import AdditionalInfo from '../components/editor/AdditionalInfo';
import Equipment from '../components/editor/Equipment';
import SeminarContent from '../components/editor/SeminarContent';
import TrainerProfile from '../components/editor/TrainerProfile';
import AboutGfu from '../components/editor/AboutGfu';
import TrustElements from '../components/editor/TrustElements';
import ExecutionTypes from '../components/editor/ExecutionTypes';
import ServiceCards from '../components/editor/ServiceCards';
import CompanyReviews from '../components/editor/CompanyReviews'
import SeminarReviews from '../components/editor/SeminarReviews'
import TrainerReviews from '../components/editor/TrainerReviews';
import ScrollSpy from '../components/editor/ScrollSpy.vue';
import Offer from '../components/editor/Offer.vue';
import PricingTableLegacy from '../components/editor/PricingTableLegacy.vue';

import { mapGetters, mapActions } from 'vuex';
import { is } from 'core-js/core/object';
import { setDocumentLanguage } from '../i18n';

export default {
  name: 'OfferEditor',
  components: {
    Heading,
    CustomerAddress,
    SeminarDetails,
    ContactPerson,
    Introduction,
    Ekomi,
    SalesStats,
    ServiceList,
    ServiceContractNotice,
    AdditionalInfo,
    Equipment,
    SeminarContent,
    TrainerProfile,
    AboutGfu,
    TrustElements,
    ExecutionTypes,
    ServiceCards,
    CompanyReviews,
    SeminarReviews,
    TrainerReviews,
    ScrollSpy,
    Offer,
    PricingTableLegacy
  },
  computed: {
    ...mapGetters([
      'offer',
      'company',
      'contact',
      'seminar',
      'trainer',
      'employee',
      'offerType',
      'trainerRating',
    ]),
    isInhouse() {
      return this.offerType && (this.offerType.id === 1);
    },
    isRemoteOnly() {
      return this.offer.isRemote && !this.offer.isClassroom;
    },
    isOpenSeminar() {
      return this.offer && parseInt(this.offer.offerType_id) === 4;
    },
  },
  data() {
    return {
      hasTrainerReviews: false,
      editable: false,
      updateable: false,
      showsave: false,
      showSeminarReviews: 1,
      randomImage: '',
    }
  },
  methods: {
    ...mapActions([
      'proxyFetchOffer',
      //'addLastViewed',
    ]),
    setReviewVisibility(type, value) {
      const field = 'show' + type.charAt(0).toUpperCase() + type.slice(1) + 'Reviews'
      this.offerSet({ [field]: value });
    },
  },
  mounted() {
    const hash = this.$route.params.offerHash;
    this.proxyFetchOffer(hash)
      .then(() => { })
      //.then(() => this.addLastViewed(hash)) //set last viewd only if in view-mode
      .catch((error) => {
        console.log(error);
        this.$router.push("/404/" + this.$route.params.offerHash);
      });
    this.editable = false;

    function hashStringToSeed(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) >>> 0; // simple hash, unsigned 32-bit
      }
      return hash;
    }

    function createSeededRandom(seed) {
      seed = hashStringToSeed(seed);
      let value = seed % 2147483647;
      if (value <= 0) value += 2147483646;

      return function () {
        value = (value * 16807) % 2147483647;
        return (value - 1) / 2147483646;
      };
    }

    const rng = createSeededRandom(hash);
    const randomDigit = Math.floor(rng() * 3) + 1;
    this.randomImage = require(`../assets/hero${randomDigit}.png`);
  },
  watch: {
    offer: {
      immediate: true,
      handler(offer) {
        if (offer) setDocumentLanguage(offer.language || 'de');
      },
    },
  }
}
</script>

<style>
.editor-save {
  height: 80px;
  position: relative;
  ;
}

.editor-save .card {
  position: fixed;
  bottom: -90px;
  left: 0px;
  width: 100%;
  height: 80px;
  transition: bottom .3s linear;

}

.editor-save.show .card {
  bottom: 0px;
}

.editor-save .card h4 {
  color: white;
}


.editor-save .card h4 .material-icons {
  border: 2px solid;
  border-radius: 5px;
  padding: 5px;
  vertical-align: baseline;
  font-size: 16px;
}

.bg-gfu {
  background-color: #266cb4;
  border-color: #266cb4;
}

.offer .header {
  background-color: #202e37;
  position: relative;
}

.offer .headerImage {
  content: "";
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top 30% center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  max-width: 1420px;
  height: 100%;
}


.offer .header h1 {
  font-size: 1.5rem;
  font-weight: 400;
}

.offer .header h2 {
  font-size: 2.25rem;
  margin-top: 0;
}

/*
.offer .header::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
}
*/

.offer .header .heading {
  text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}


.offer .header-img {
  margin-right: -130px;
}

.offer .bg-base {
  background-color: white;
  padding: 20px 0;
}

.offer .ekomi-wrapper {
  height: 111px;
  overflow: hidden;
  margin-bottom: 20px;
}

@media (min-width: 768px) {
  .offer .ekomi-wrapper {
    height: 176px;
  }
}

.offer .ekomi {
  font-size: 13px;
}

.offer .alert-gebucht {
  background-color: #B0DDB6;
  color: #0B352D;
}


@media screen and (max-width: 992px) {
  .offer .header {
    
  }

  .offer .header-img {
    height: 200px;
    float: right;
    margin-right: -60px;
  }
}

@media screen and (max-width: 767px) {
  .offer .ekomi {
    padding: 0px 50px;
  }

  .offer .header-img-container {
    display: none;
  }
}

.offer .ekomi img {
  margin-bottom: 20px;
}

.offer .offer-imprint {
  margin-top: 24px;
  padding-bottom: 12px;
}

.offer .offer-imprint-line {
  height: 2px;
  background-color: #fdc41f;
  margin-bottom: 14px;
}

.offer .offer-imprint-text {
  font-size: 0.85rem;
  line-height: 1.3;
  color: #033878;
  margin-bottom: 8px;
}

.offer .offer-imprint-text strong {
  color: #033878;
  font-weight: 600;
}

.offer .ekomi p {
  margin-bottom: 15px;
}

.offer .introduction p {
  margin-bottom: 12px;
}

.offer .card img {
  max-width: 100%;
}

.offer .container-fluid {
  max-width: 1170px;
}

.offer ul {
  margin-top: 0;
  margin-bottom: 10px;
}

.offer p {
  margin: 0;
}

.offer .price-table>tbody>tr>td {
  border-color: #ddd;
  padding-left: 20px;
  padding-right: 20px;
}

.offer .price-table ul {
  padding: 0;
  list-style-type: none;
}

.price-table table tr td:last-child {
  text-align: right;
}

.highlight-row {
  background: rgb(4, 43, 96);
  color: #fff;
}

.highlight-row>td:first-child:first-letter {
  font-size: 2.2rem;
  margin-left: 0;
  margin-right: 10px;
  position: relative;
  top: 10px;
  color: hsla(0, 0%, 100%, .5);
}

.service ul,
.trainer ul,
.trainer-profile ul,
.sem-profileinar ul,
.seminar-content ul,
.equipment ul {
  padding-left: 0;
  list-style-type: none;
}

.service ul>li,
.trainer ul>li,
.trainer-profile ul>li,
.seminar-content ul>li,
.equipment ul>li {
  padding-left: 25px;
  margin-top: 10px;
  position: relative;
}

.seminar ul>li {
  margin-top: 10px;
  position: relative;
}

.service ul>li:before {
  content: "\e5ca";
  font-family: Material Icons;
  position: absolute;
  left: 0;
  top: -2px;
  font-size: 17px;
  color: rgb(3, 56, 120);
}

.trainer ul>li:before,
.trainer-profile ul>li:before,
.seminar-content ul>li:before,
.equipment ul>li:before {
  content: "\e5cc";
  font-family: Material Icons;
  position: absolute;
  left: 0;
  top: 10px;
  font-size: 17px;
  line-height: 0px;
}

.seminar ul>li:before {
  content: "chevron_right";
  font-family: Material Icons;
  font-size: 17px;
  vertical-align: sub !important;
  ;
  position: relative !important;
}

.seminar ul>li,
.trainer ul>li,
.trainer-profile ul>li,
.seminar-content ul>li {
  margin-bottom: 0px;
  margin-top: 3px;
}

.service-icon {
  margin-top: -10px;
  position: relative;
  top: 5px;
  margin-right: 7px;
  color: rgb(3, 56, 120);
}

.footer {
  background: rgb(4, 43, 96);
  padding-top: 20px;
  padding-bottom: 20px;
  color: hsla(0, 0%, 100%, .7);
  margin-top: 40px;
}

.offer .price-table .card>div {
  overflow-x: auto;
  display: block;
  -webkit-overflow-scrolling: touch;
}

.offer .price-table table {
  min-width: 500px;
}

.trainer-scrollable {
  max-height: 670px;
  min-height: 500px;
  overflow-y: auto;
  padding-right: 24px;
  margin-right: -24px;
}

.btn-cta {
  color: #fff;
  background-color: #f77635;
  border-color: #ec6d2c;
  cursor: pointer;
}

.mce-content-body {
  height: 100%;
}

#go-top .material-icons {
  font-size: 1.2em;
}

.loading-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-icon {
  content: " ";
  display: block;
  width: 16px;
  height: 16px;
  background-image: url('data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==');
}
</style>
